module.exports={
    "over_size_message":"您上傳的視頻大於10MB，我們將壓縮後上傳，請點擊“確定”按鈕繼續上傳。",
    "file_type_error":"您上傳的文件不是圖片格式，請重新選擇文件上傳！",
    "upload_error":"上傳失敗！（錯誤碼：2000）請重試...",
    "watermark_remove_over_size":"您上傳的視頻大於5MB，建議您使用我們的免費在線圖片壓縮器對圖片進行壓縮。<a class=\"jump-link\" href=\"https://www.tipard.com/zh-TW/image-compressor-online/\">點此了解更多</a>。",
    "watermark_remove_file_type_error":"您上傳的文件不是圖片格式，請重新選擇文件上傳！",
    "watermark_remove_image_type_error":"該圖片格式暫不支持，請上傳JPG，JPEG，PNG，BMP格式圖片。",
    "watermark_remove_upload_error":"識別失敗（錯誤碼：2001），請重試...",
    "watermark_remove_processing":"正在處理圖片...",
    "watermark_remove_not_save":"您選擇的區域不會被保留，您確定要裁剪嗎？",
    "watermark_remove_back_home":"當前狀態將不會保存，您確定要返回首頁嗎？",
    "watermark_remove_new_image":"當前狀態將不會保存，您確定要切換新圖片嗎？",
    "watermark_select":"選擇",
    "watermark_select_area":"請在點擊去除按鈕之前選擇您想擦除的水印區域。",
    "watermark_beyond_4k":"很抱歉，您選擇的圖片分辨率超過了4K，我們暫不支持處理該分辨率圖片。",
    "watermark_beyond_pixel_1":"您選擇的圖片分辨率超過了<span>%spx</span><span>&times;%spx</span>。該圖片暫不支持處理，請重新選擇。",
    "watermark_beyond_pixel_2":"遊客用戶只能處理<span>%s</span>張<span>%spx</span>x<span>%spx</span>分辨率的圖片，請登錄後繼續使用。",
    "watermark_beyond_size_1":"你選擇的圖片大小超過了<span>%sMB</span>。該圖片暫不支持處理，請重新選擇。",
    "watermark_beyond_size_2":"你選擇的圖片大小超過了<span>%sMB</span>。遊客用戶只能處理小於<span>%sMB</span>的圖片，請登錄後繼續使用。",
    "no_user_down":"遊客用戶只能下載<span>%s</span>張原圖，請登錄後繼續下載。登錄用戶還可保留7天內的編輯記錄。繼續下載寬或高為<span>%spx</span>的圖片。",
    "no_down_rights":"無法下載高清原圖，請升級您的購買計劃！您也可以繼續下載<span>%spx</span>的低質量圖片。",
    "error_40001":"錯誤碼：40001。請聯繫我們",
    "error_40099":"錯誤碼：40099。請聯繫我們",
    "down_btn":"正在準備下載，請稍等...",
    "noRemove_down_btn":"您尚未選擇任何去水印區域。請選擇您想擦除的水印區域，並點擊去除按鈕。然後您可以下載去除水印的圖片。",
    "history_open":"正在打開修改後的圖片，請稍等...",
    "maskRightsMonitor_info":"升級權益頁面將在新的標籤頁中打開，升級後，您的計劃將會自動同步。",
    "maskLoginMonitor_info":"登錄頁已打開，請在頁面中完成登錄。登錄或註冊成功後，當前頁面將會自動同步登錄信息，請不要關閉。",
    "photo_rights_info":"當前可下載<span><i class=\"num\">2</i>張高清原圖</span>。<a href=\"https://account.tipard.com\" target=\"_blank\">查看更多>></a>",
    "rights_original":"打開“使用Image Enhancer功能減少畫面損失”設置前，您需要先升級您的賬戶",
    "Brush":"筆刷",
    "Lasso":"套索",
    "Polygonal":"多邊形套索",
    "Eraser":"橡皮擦",
    "Free":"自由",
    "More":"更多：",
    "Select":"選擇",
    "Remove":"去除",
    "BrushSize":"筆刷大小：",
    "AspectRatio":"裁剪比例：",
    "Upload":"新圖片",
    "History":"歷史記錄",
    "Login":"登錄",
    "MyAccount":"我的賬戶",
    "Logout":"登出",
    "Usinghelp":"使用幫助>>",
    "Enhancer":"使用Image Enhancer功能減少畫面損失",
    "Download":"下載",
    "Guide":"指引",
    "Polygonal1":"多邊形套索：",
    "Polygonal_info":"單擊鼠標左鍵，一次識別一個點。",
    "Lasso1":"套索：",
    "Lasso_info":"長按鼠標左鍵套索水印區域。",
    "Brush1":"筆刷：",
    "Brush_info":"長按鼠標左鍵進行精確選擇。",
    "Eraser1":"橡皮擦：",
    "Eraser_info":"清除已選區域中不需要的部分。",
    "Click":"點擊",
    "the":"",
    "click_info":"按鈕，開始消除水印。",
    "PleaseUploadImages":"請上傳圖片。",
    "CropInfo":"水印去除完成後，您可以點擊裁剪按鈕繼續裁剪圖片，也可以點擊下載按鈕直接保存當前圖片。",
    "Crop":"裁剪",
    "Back":"返回",
    "DownloadCropped":"下載裁剪後圖片",
    "Cancel":"取消",
    "FreeWatermarkRemover":"免費去水印",
    "Processing":"處理中",
    "NewImage":"新圖片",
    "Retry":"重試",
    "Yes":"是",
    "No":"否",
    "FailureFeedback":"錯誤反饋",
    "removeTip":"完成水印標記後，點擊去除按鈕進行水印去除。",
    "rightDown":"下載低質量圖片",
    "history_will":"將過期",
    "Expired":"（已過期）",
	"uploadImage":"添加圖像",
    "uploadImageInfo":"或將您的圖像文件放在這里以去除水印！",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"無限制",
    "watermark_beyond_pixel_3":"當前權益最高僅支持<span>%s&times;%s分辨率</span>的图片，請先升級您的權益。",
    "watermark_beyond_size_3":"當前權益最高僅支持<span>%sMB</span>的图片，請先升級您的權益。",
    "no_user_login":"新用戶登錄即可獲得兩次高清原圖下載福利。<span class=\"loginMaskbtn\">立即登錄>></span>",
    "Upgrade":"升級權益",
    "Loading":"加載中...",
    "SelectAll":"全選",
    "Open":"打開",
    "Delete":"刪除",
    "Clear":"清除無效",
    "noHistory":"無歷史記錄",
    "Close":"關閉",
    "buyUserInfo":"恭喜！您已成功升級權益。請返回首頁使用本產品。",
    "buyNoUserInfo":"恭喜！您已成功升級。福利已與您升級時留下的郵箱綁定。請使用註冊或鏈接到電子郵件地址的帳戶<span class=\"loginMaskbtn\">登錄以使用福利</span>。如果您還沒有註冊或鏈接到該電子郵件地址的帳戶，請<span class=\"registerMaskbtn\">使用該電子郵件地址註冊一個帳戶</span>或將其他帳戶鏈接到此電子-使用福利的郵件地址。",
    "GetStarted":"開始",
    "AccessTo":"進入：",
    "imagesOfwatermarkremoval":"去除水印的圖片",
    "upTo":"上限為",
    "perImage":"每張圖片",
    "Support":"支持",
    "resolution":"分辨率",
    "PrepaidPackage":"預付套餐",
    "PayasYouGo":"現收現付",
    "TaxIncl":"含稅",
    "Checkout":"結帳",
    "imagesDay":"圖片/天",
    "imagesMonthly":"圖片/每月",
    "image":"圖片",
    "images":"圖片",
    "imageSize":"圖片尺寸",
    "buyInfo1":"第三方<span>画质增強</span>集成技术",
    "buyInfo2":"保留7天內的編輯歷史",
    "buyInfo3":"優先處理",
    "buyInfo4":"7x24 用戶服務支持",
    "buyInfo5":"24 小時後過期",
    "buyInfo6":"沒有訂閱。沒有自動更新！",
    "buyInfo7":"可以在任何時間永久使用",
    "dayPlan":"日訂閱計劃",
    "Lifetime":"終身訂閱計劃",
    "note":"<span>注意</span>：請注意，購買的權益與付費時提供的電子郵箱綁定。 要成功使用權益，請使用對應的電子郵寄地址注册或登入。",
    "buy_now": "立即購買",
    
    "banner_title": "AI照片清理 - 您想要多少個學分",
    "banner_info": "1個學分= 1圖像：您將花費1個信用來處理並節省大於600×600像素的圖像。請從每月或終身計劃中進行選擇。",
    "monthlyPlan_title": "每月計劃",
    "monthlyPlan_displayPricePerCredit": "/信用",
    "monthlyPlan_plan1_credits": "學分/mo",
    "monthlyPlan_feature1": "<span>無風險：</span> 30天退款保證",
    "monthlyPlan_feature2": "<span>自動：</span>自動更新信用",
    "monthlyPlan_feature3": "<span>靈活：</span>降級，升級或取消任何時間",
    "oneTimePurchase_title": "一次性購買",
    "oneTimePurchase_plan5_credits": "學分/終生",
    "oneTimePurchase_feature1": "30天退款保證",
    "oneTimePurchase_feature2": "購買後永久有效",
    "payment_title": "您可以選擇多種付款方式",
    "payment_image_alt": "付款方式",
    "faq_title": "關於積分購買的常見問題",
    "faq_question1_title": "什麼是學分？",
    "faq_question1_info": "我們的服務在信用單位中衡量。信用是去除水印中使用消耗的單位。刪除圖像上的水印並保存下來，您將花費信用。",
    "faq_question2_title": "我應該選擇每月訂閱還是一次性購買？",
    "faq_question2_info": "對於不規則的圖像任務或不經常使用的要求，您可以選擇一次購買，可以根據圖像要求購買適當的信用額。相反，如果您經常需要處理照片，則可以選擇每月訂閱以每月獲得足夠的信用。",
    "faq_question3_title": "如果我耗盡了學分怎麼辦？",
    "faq_question3_info": "您可以根據您的照片處理需求來升級訂閱或繼續購買一次性購買計劃。升級或購買後，新的積分將立即出現在您的帳戶中。",
    "faq_question4_title": "我可以升級，降級或取消訂閱嗎？",
    "faq_question4_info": "是的，你可以。您可以隨時升級或降級訂閱。如果您不希望購買的計劃在下個月續訂，則可以立即取消它。",
    "whyChoose_title": "為什麼選擇Tipard",
    "whyChoose_reason1_title": "安全下載",
    "whyChoose_reason1_info": "Tipard的節目100％乾淨，安全",
    "whyChoose_reason2_title": "專業技術",
    "whyChoose_reason2_info": "熟練的團隊提供專業產品",
    "whyChoose_reason3_title": "24/7客戶支持",
    "whyChoose_reason3_info": "一直在患者顧問服務",
    "whyChoose_reason4_title": "30天的錢回來",
    "whyChoose_reason4_info": "保證在30天內退還給用戶",
    "whyChoose_reason5_title": "1,000,000多種用戶",
    "whyChoose_reason5_info": "超過100萬人使用和信任",
    "whyChoose_reason6_title": "160多個國家",
    "whyChoose_reason6_info": "在160多個國家和地區出售"
}